import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import RotatingHeadline from "@/components/RotatingHeadline";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b">
        <div className="container flex h-16 items-center justify-center px-4 md:px-6">
          <div className="flex items-center justify-center">
            <Link to="/">
              <img
                src="/icons/logo-with-text-black.png"
                alt="Triathlon Achievements Logo"
                width={120}
                height={40}
                className="h-10 w-auto"
                style={{ maxWidth: "100%", objectFit: "contain" }}
              />
            </Link>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <section className="w-full py-12 md:py-24">
          <div className="container px-4 md:px-6">
            <div className="flex flex-col items-center justify-center space-y-4 text-center">
              <div className="space-y-2">
                <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
                  Wear Your Triathlon Victories
                </h1>
                <p className="mx-auto max-w-[700px] text-gray-500 md:text-xl">
                  You've worked hard for your achievements, you deserve to show
                  off a little
                </p>
              </div>
            </div>
            <div className="mx-auto grid max-w-5xl items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12">
              <img
                src="/quarter-zip.png"
                alt="Triathlon Quarter Zip"
                width={500}
                height={500}
                className="mx-autorounded-xl object-center sm:w-full lg:order-last"
                // style={{ maxWidth: '100%', objectFit: 'cover' }}
              />
              <div className="flex flex-col justify-center space-y-4">
                <div className="space-y-2">
                  <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">
                    Premium Quarter Zip
                  </h2>
                  <p className="max-w-[600px] text-gray-500 md:text-xl">
                    Showcase your triathlon achievements with our premium
                    quarter zip featuring custom embroidered badges.
                  </p>
                </div>
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Custom embroidered race badges</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Premium quality fabric</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="h-5 w-5"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>Unique to your achievements</span>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <Link to="/customize" className="w-full sm:w-64">
                    <Button className="w-full">Customize Yours</Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Rotating Settings Headline */}
        <RotatingHeadline />

        {/* Race Gallery */}
        <section className="w-full py-16 md:py-24">
          <div className="container px-4 md:px-6">
            <div className="flex flex-col items-center justify-center space-y-4 text-center mb-12">
              <div className="space-y-2 max-w-3xl">
                <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl">
                  From Start to Finish
                </h2>
                <p className="mx-auto text-gray-500 md:text-xl">
                  Every race tells a story. Let your quarter zip tell yours.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="relative h-[300px] md:h-[500px] overflow-hidden rounded-lg shadow-lg">
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/mario-la-pergola-XEOB-7BwrmU-unsplash.jpg-GXPOr8fOCp5MalXAdxPmi6dlmGkvoa.jpeg"
                  alt="Mass triathlon swim start"
                  className="object-cover w-full h-full"
                />
              </div>
              <div className="grid grid-cols-2 gap-6">
                <div className="relative h-[240px] overflow-hidden rounded-lg shadow-lg">
                  <img
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/tony-pham-K2xGNNcQn_w-unsplash.jpg-fRviZULdB22U5x3qXWo79acJA3Al3l.jpeg"
                    alt="Triathletes cycling in a group"
                    className="object-cover w-full h-full"
                  />
                </div>
                <div className="relative h-[240px] overflow-hidden rounded-lg shadow-lg">
                  <img
                    src="/images/stock/wilhelm-running.jpg"
                    alt="Swimmers in open water"
                    className="object-cover w-full h-full"
                  />
                </div>
                <div className="relative h-[240px] overflow-hidden rounded-lg col-span-2 shadow-lg">
                  <img
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/diana-rafira-jth6_VDCOIo-unsplash.jpg-s3ATjgeMWiUdC7EILBOUQonq5Dy49u.jpeg"
                    alt="Triathlete cycling at sunset"
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-24">
          <div className="container px-4 md:px-6 mx-auto text-center">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl font-spartan">
              How It Works
            </h2>
            <div className="flex flex-col items-center justify-center space-y-4 text-center mb-4">
              <div className="space-y-2 max-w-3xl">
                <p className="mx-auto text-gray-500 md:text-xl">
                  Three simple steps to get your personalized triathlon quarter
                  zip.
                </p>
              </div>
            </div>

            <div className="mx-auto grid max-w-5xl gap-8 py-12 md:grid-cols-3">
              <Card>
                <CardContent className="p-6">
                  <div className="flex flex-col items-center space-y-2 text-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-6 w-6"
                      >
                        <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                        <polyline points="14 2 14 8 20 8" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold">Submit Your Races</h3>
                    <p className="text-sm text-gray-500">
                      Enter all details of all your completed races.
                    </p>
                  </div>
                </CardContent>
              </Card>
              <Card>
                <CardContent className="p-6">
                  <div className="flex flex-col items-center space-y-2 text-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-6 w-6"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold">Preview Your Design</h3>
                    <p className="text-sm text-gray-500">
                      See a real-time preview of how your personalized quarter
                      zip will look.
                    </p>
                  </div>
                </CardContent>
              </Card>
              <Card>
                <CardContent className="p-6">
                  <div className="flex flex-col items-center space-y-2 text-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="h-6 w-6"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-bold">Order & Verification</h3>
                    <p className="text-sm text-gray-500">
                      Complete your purchase and we'll verify your races before
                      production.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Founder Story */}
        <section className="w-full py-16 md:py-24 bg-white">
          <div className="container px-4 md:px-6">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-12">
              Founding Tritan
            </h2>
            <div className="grid gap-12 lg:grid-cols-2 items-center">
              <div className="relative overflow-hidden rounded-lg shadow-xl">
                <img src="/images/tritan-selfie.jpg" alt="Founder of Tritan" />
              </div>
              <div className="space-y-6">
                <div>
                  <p className="text-gray-500 md:text-lg mb-6">
                    Early mornings, social sacrifices, five hour weekend bike
                    rides. Triathlon is not for the faint of heart, it's a big
                    part of our lives and the lives of our families (whether
                    they like it or not). As much as we do train, I felt we were
                    missing a way to recognise each other in the wild and spark
                    conversations.
                  </p>
                  <p className="text-gray-500 md:text-lg mb-6"></p>
                  <p className="text-gray-500 md:text-lg">
                    Every races tells a story and I want to ask you about yours.
                    Welcome to the Tritan family.
                  </p>
                </div>
                <div className="flex items-center gap-4">
                  <div className="h-px flex-1 bg-gray-200"></div>
                  <span className="text-sm font-medium">
                    Wilhelm Klopp, Founder of Tritan
                  </span>
                  <div className="h-px flex-1 bg-gray-200"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer className="border-t">
        <div className="container flex flex-col gap-4 py-10 md:flex-row md:gap-8 md:py-12">
          <div className="flex flex-col gap-2 md:gap-4">
            <Link to="/">
              <img
                src="/icons/left-chest-logo-black.svg"
                alt="Tritan Logo"
                width={60}
                height={40}
                className="h-20 w-auto"
                style={{ maxWidth: "100%", objectFit: "contain" }}
              />
            </Link>
            <p className="text-sm text-gray-500">
              Wear your triathlon victories with pride.
            </p>
          </div>
        </div>
        <div className="border-t py-6">
          <div className="container flex flex-col items-center justify-between gap-4 md:flex-row">
            <p className="text-center text-sm text-gray-500 md:text-left">
              2025 Tritan. All rights reserved.
            </p>
            <div className="flex gap-4">
              <Link
                to="https://instagram.com/tritanclub/"
                className="text-gray-500 hover:text-gray-900"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                </svg>
                <span className="sr-only">Instagram</span>
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
